import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider, Authenticated } from './lib/auth'
import { ApolloProvider } from './data/apollo'

import Appsignal from '@appsignal/javascript'
import { plugin as appSignalBreadcrumbsNetwork } from '@appsignal/plugin-breadcrumbs-network'
import { ErrorBoundary } from '@appsignal/react'

import ReactGA from 'react-ga4'

import ErrorDisplay from './components/ErrorDisplay'
import Routes from './components/Routes'

import './App.css'
import Layout from './components/Layout'

const appsignal = new Appsignal({
  key: import.meta.env.VITE_APPSIGNAL_PUSH_API_KEY,
  revision: import.meta.env.VITE_GIT_SHORT_SHA
})
appsignal.use(appSignalBreadcrumbsNetwork())

if (import.meta.env.VITE_GA4_MEASUREMENT_ID != null) {
  ReactGA.initialize(import.meta.env.VITE_GA4_MEASUREMENT_ID)
}

const App = (): JSX.Element => (
  <HelmetProvider>
    <AuthProvider>
      <ApolloProvider>
        <BrowserRouter>
          <Layout>
            <ErrorBoundary
              instance={appsignal}
              fallback={(error: any) => <ErrorDisplay error={error} />}
            >
              <Authenticated>
                <Routes />
              </Authenticated>
            </ErrorBoundary>
          </Layout>
        </BrowserRouter>
      </ApolloProvider>
    </AuthProvider>
  </HelmetProvider>
)

export default App
